module.exports = __webpack_public_path__ + "img/unverified_icon.719d58b1.svg";